/**
 * Which ZKX Trade deployment the swap stack talks to — `ZKX_TRADE_API_URL` in
 * `extension/.env`.
 *
 * There is deliberately NO built-in default, same rule as the four LibertySwap
 * bases next door. It used to default to the DEV host, which meant a production
 * build that simply did not carry the key sent real users' swaps to the dev
 * aggregator without a word — the host is not visible anywhere in the UI, so
 * nothing would have surfaced it. A getter that throws and names the missing key
 * is the loud failure that mistake deserves.
 *
 * `scripts/validateEnv.js` checks the key for every swap-capable target, so the
 * throw below is a backstop, not the first line of defence.
 *
 * This module is env-agnostic (submodule rule): it never reads `process.env`
 * itself, the app pushes the value in at boot from `common/config/env/env.ts`.
 */
let configuredBase: string | null = null

const normalizeBase = (url: string | null | undefined): string | null => {
  const trimmed = typeof url === 'string' ? url.trim() : ''
  if (!trimmed) return null

  // Callers configure a base, not a directory; a trailing slash would produce
  // `//routes` once a path is appended.
  return trimmed.replace(/\/+$/, '')
}

/** Call once at boot, before any ZKX Trade request. */
export function setZkxTradeApiBase(url: string | null | undefined): void {
  configuredBase = normalizeBase(url)
}

export function getZkxTradeApiBase(): string {
  if (!configuredBase)
    throw new Error('ZKX Trade API base is not configured — set ZKX_TRADE_API_URL in .env')

  return configuredBase
}
